// Phase 9 — surfaces auth-expired events from the api client.
//
// The api client calls `_authListener('expired')` after a 401 that
// couldn't be silently refreshed. We register that listener once on
// mount and show a non-blocking toast plus a top banner. The user can
// re-login without losing the page they were on.

import { useEffect, useState } from 'react';
import { setAuthExpiredListener, clearToken } from '@/integrations/api/client';
import { Button } from '@/components/ui/button';
import { useSafeNavigate } from '@/hooks/useSafeNavigate';

export function AuthExpiredBanner() {
  const [expired, setExpired] = useState(false);
  const navigate = useSafeNavigate();

  useEffect(() => {
    setAuthExpiredListener(() => setExpired(true));
    return () => setAuthExpiredListener(null);
  }, []);

  if (!expired) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-[60] bg-amber-500/95 text-amber-950 px-4 py-2 flex items-center justify-between shadow"
    >
      <span className="text-sm font-medium">Your session has expired. Please sign in again to continue.</span>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={() => {
            clearToken();
            navigate('/login', { state: { from: window.location.pathname + window.location.search } });
          }}
        >
          Sign in
        </Button>
        <Button size="sm" variant="ghost" onClick={() => setExpired(false)}>
          Dismiss
        </Button>
      </div>
    </div>
  );
}
